var stepsOrgs = [{
  element: '#add-new',
  popover: {
    title: 'Add New Organisation',
    position: 'right'
  }
}];
export default stepsOrgs;